export default function exportProductListingData() {
  return {
    'PartNumber': 'PartNumber',
    'CustomerPartNumbers': 'Customer Part Number',
    'Manufacturer': 'Manufacturer',
    'Availability': 'Stock (Availability)',
    'Lead time': 'Lead Time',
    'Quantity': 'Quantity',
    'Min': 'Min',
    'Mult': 'Mult',
    'Currency': 'Currency',
    'Datasheet': 'Datasheet',
    'Description': 'ProductDescription'
  }
};

export function functionDataOrder() {
  return [
    "PartNumber",
    "Customer Part Number",
    "Manufacturer",
    "Stock (Availability)",
    "Lead Time",
    "Quantity",
    "Min",
    "Mult",
    "Currency",
    "Datasheet",
    "Description"
  ];
}